// (function () {
// 	'use strict';

//     const module = angular.module('imApp');

//     module.component('travelBillReject', {
//         templateUrl: 'views/components/views/travelBillReject/travelBillReject.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'travelBillRejectService', function ($stateParams, stateService, translateService, modalService, travelBillRejectService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let travelBillNo = $stateParams.travelbill_no;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//     		vm.model = {
//                 edit: {},
//     			lockedSave: false
//     		};

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//     		// #region LOAD PROCEDURE CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await travelBillRejectService.getEdit({ travelbill_no: travelBillNo }))[0];
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 travelBillRejectService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                         stateService.back('2');
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 loadEdit();
//             }

//             // #endregion ON INIT FUNCTION

//     	}]
//     });
// })();
